import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Town } from "../../../types/Town";
import { useLazyGetTownByNameQuery } from "../../../api/Town";
import { Col, Row } from "antd";
import { bpTheme, useTheme } from "../../../Providers/ThemeProvider";
import { useMediaQuery } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import { Container, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export default function TownDetailView() {
  const { name } = useParams();
  const isSm = useMediaQuery(bpTheme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [getTown] = useLazyGetTownByNameQuery();
  const [town, setTown] = useState<Town>();
  const [error, setError] = useState(false);

  const initTown = useCallback(() => {
    getTown({ name: name!.replace("-", " ") }).then(
      ({ data }) => {
        if (data) {
          setTown(data.town);
        } else {
          setError(true);
        }
      },
      () => {
        setError(true);
      }
    );
  }, [name]);

  useEffect(() => {
    if (!name) {
      navigate(-1);
    } else {
      initTown();
    }
  }, [name, initTown]);

  const handleDownload =
    (signedUrl: string) => (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      const link = document.createElement("a");
      link.href = signedUrl;
      link.setAttribute("download", "file"); // Nome del file (opzionale, alcuni URL potrebbero non supportarlo)
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

  const renderTown = useCallback(() => {
    if (error) {
      return (
        <Alert variant="danger" className="py-2 mt-4 w-50 m-auto">
          <FontAwesomeIcon icon={faExclamationTriangle} />
          <span className="ms-2">
            C'è stato un errore, per favore riprova più tardi
          </span>
        </Alert>
      );
    }

    return (
      <div>
        <p
          style={{
            textTransform: "uppercase",
            textAlign: "center",
            fontSize: isSm ? "6vw" : "2vw",
            fontWeight: 600,
            letterSpacing: "8px",
            marginBottom: 32,
          }}
        >
          {town!.name}
        </p>
        <span
          className="text-center"
          dangerouslySetInnerHTML={{ __html: town!.description || "" }}
        />
        <Row
          style={{
            justifyContent: isSm ? "center" : "space-around",
            gap: 16,
            textAlign: "center",
            paddingTop: 12,
          }}
        >
          {!isSm ? (
            <>
              <Col span={8}>
                <p className="h4 text-uppercase">Link Utili:</p>
                <div className="d-flex flex-column">
                  {(town!.links || []).map((link, index) => (
                    <span key={index}>
                      <a
                        href={`${link.url}`}
                        style={{
                          color: theme.colors.primary,
                          textDecoration: "underline",
                          fontSize: 16,
                        }}
                        target="_blank"
                        rel="noopener"
                      >
                        {link.label}
                      </a>
                    </span>
                  ))}
                </div>
              </Col>
              <Col span={8}>
                <p className="h4 text-uppercase pb-2">Download:</p>
                <div className="d-flex flex-column gap-2">
                  {(town!.buttons || []).map((button, _index) => (
                    <button
                      onClick={handleDownload(button.signedUrl || "")}
                      style={{
                        alignSelf: "center",
                        maxWidth: "50%",
                        padding: "12px 20px",
                        backgroundColor: theme.colors.secondaryButton,
                        border: "none",
                        color: "#FFF",
                        fontSize: "16px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        transition:
                          "background-color 0.3s ease, transform 0.2s ease",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          theme.colors.secondaryButtonHover)
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          theme.colors.secondaryButton)
                      }
                      onMouseDown={(e) =>
                        (e.currentTarget.style.transform = "scale(0.95)")
                      }
                      onMouseUp={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {button.label}
                    </button>
                  ))}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col span={24}>
                <p className="h4 text-uppercase pb-3">Link Utili:</p>
                <div className="d-flex flex-column">
                  {(town!.links || []).map((link, index) => (
                    <span key={index}>
                      <a
                        href={`${link.url}`}
                        style={{
                          color: "#FFF",
                          textDecoration: "underline",
                          fontSize: 16,
                        }}
                        target="_blank"
                        rel="noopener"
                      >
                        {link.label}
                      </a>
                    </span>
                  ))}
                </div>
              </Col>
              <Col span={24}>
                <p className="h4 text-uppercase pb-3">Download:</p>
                <div className="d-flex flex-column gap-2">
                  {(town!.buttons || []).map((button, index) => (
                    <button
                      onClick={handleDownload(button.signedUrl || "")}
                      style={{
                        alignSelf: "center",
                        padding: "12px 20px",
                        backgroundColor: theme.colors.secondaryButton,
                        border: "none",
                        color: "#FFF",
                        fontSize: "16px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        transition:
                          "background-color 0.3s ease, transform 0.2s ease",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          theme.colors.secondaryButtonHover)
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          theme.colors.secondaryButton)
                      }
                      onMouseDown={(e) =>
                        (e.currentTarget.style.transform = "scale(0.95)")
                      }
                      onMouseUp={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      {button.label}
                    </button>
                  ))}
                </div>
              </Col>
            </>
          )}
        </Row>
      </div>
    );
  }, [town, handleDownload, error]);

  const renderAsyncContent = useCallback(() => {
    return town ? (
      renderTown()
    ) : (
      <div className="d-flex justify-content-center py-5 my-5">
        <TailSpin
          height={100}
          width={100}
          color={theme.colors.primary}
          radius="1"
        />
      </div>
    );
  }, [town, renderTown]);

  return (
    <Container
      className="px-5 justify-content-center text-center"
      style={{
        position: "relative",
        paddingTop: "12vh",
        paddingBottom: "8vh",
        minHeight: "60vh",
      }}
    >
      <img
        src={require("../../../assets/img/logo.png")}
        style={{ width: 120, height: 80, marginBottom: 16 }}
        alt="Logo"
      />
      {renderAsyncContent()}
    </Container>
  );
}
